/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Monitoring API
 * A comprehensive portfolio monitoring and reporting tool for DeFi users to track investments/balances across multiple protocols, discover yield opportunities, and generate reports for tax and accounting purposes.  The API enables users to: - Monitor balances and earnings across lending, liquid staking, LP positions, vaults, and traditional staking - Discover new yield opportunities with advanced filtering and sorting - Generate downloadable reports for taxes, accounting, and personal tracking - Aggregate data at multiple levels (combined, by category, by protocol, by wallet) - Track performance over time with historical data
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * PortfolioInsightsApi - axios parameter creator
 */
export const PortfolioInsightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve the current APY for the requested chains
         * @summary Get network APY
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioV1ApyGet: async (chainIDs, options = {}) => {
            const localVarPath = `/portfolio/v1/apy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (chainIDs) {
                localVarQueryParameter['chainIDs'] = chainIDs;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PortfolioInsightsApi - functional programming interface
 */
export const PortfolioInsightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PortfolioInsightsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve the current APY for the requested chains
         * @summary Get network APY
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioV1ApyGet(chainIDs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioV1ApyGet(chainIDs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioInsightsApi.portfolioV1ApyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PortfolioInsightsApi - factory interface
 */
export const PortfolioInsightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PortfolioInsightsApiFp(configuration);
    return {
        /**
         * Retrieve the current APY for the requested chains
         * @summary Get network APY
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioV1ApyGet(chainIDs, options) {
            return localVarFp.portfolioV1ApyGet(chainIDs, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PortfolioInsightsApi - object-oriented interface
 */
export class PortfolioInsightsApi extends BaseAPI {
    /**
     * Retrieve the current APY for the requested chains
     * @summary Get network APY
     * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioV1ApyGet(chainIDs, options) {
        return PortfolioInsightsApiFp(this.configuration).portfolioV1ApyGet(chainIDs, options).then((request) => request(this.axios, this.basePath));
    }
}
